import UserProfileNoImg from "@/../../public/images/no-image.jpg";

import { SlBell } from "react-icons/sl";
import { useEffect, useState } from "react";
import Toast from "react-bootstrap/Toast";
import Dropdown from "react-bootstrap/Dropdown";
import NavItem from "react-bootstrap/NavItem";
import NavLink from "react-bootstrap/NavLink";
import { CiUser } from "react-icons/ci";
// import { TbNotes } from "react-icons/tb";
import { AiOutlineMessage } from "react-icons/ai";

import { SlMenu } from "react-icons/sl";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { AppRoute } from "../../router/routerConstants";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { notificationList } from "../../service/apis/notification.api";
import {
  addNotification,
  clearNotifications,
  setNotifications,
} from "../../store/notification.store";
import { Notification } from "../../config/Notification";
import NotificationScreen from "../../screens/jobseeker/common/notification";
import { connectSocket, getSocket } from "../../service/socketService";
import {
  addMessage,
  clearChatData,
  setActiveChatId,
  setChatHistory,
  setMessageList,
} from "../../store/chat.store";
import {
  getChatBoardList,
  getMessageList,
} from "../../service/apis/message.api";
import { clearAllStorage, showError } from "../../utils/Common";
import { MdOutlineLogout } from "react-icons/md";
import { Form, Modal } from "react-bootstrap";
import { logOut } from "../../store/auth.store";
import EmployerSidebarScreen from "./employer-sidebar";

const EmployerHeaderScreen = () => {
  const [NavigateTo] = useCustomNavigate();
  const [show, setShow] = useState(false);

  const [showoffcanvas, setShowp] = useState(false);
  const offhandleClose = () => setShowp(false);
  const ddhandleShow = () => setShowp(true);

  const [showWork, setShowWork] = useState(false);
  const handleCloseWK = () => setShowWork(false);

  const handleShowWK = () => setShowWork(true);
  const { user } = useSelector((state: RootState) => state.authSlice);

  const [notificationAlert, setNotificationAlert] = useState<any>(null);
  const [isShowNotificationAlert, setShowNotificationAlert] = useState(false);

  const { notifications } = useSelector(
    (state: RootState) => state.notificationSlice
  );

  const { activeChatId } = useSelector(
    (state: RootState) => state.chatSlice
  );
  const dispatch = useDispatch();

  useEffect(() => {
    // Initialize socket connection
    connectSocket();
    const socket = getSocket();

    socket.emit("join", user?._id);
    // console.log(user?.notification,555);
    
    socket.on("applicationStatusUpdate", handleSocketNotification);
    socket.on("newapplicationadded", handleSocketNotification);
    socket.on("sendemployerforapprove", handleSocketNotification);
    socket.on("newmessageget", async (message) => {
      // console.log("incoming msg", message);

      //  update the Redux store with the new message
      dispatch(addMessage(message.resentMessage));

      // Recall getAllMessages to fetch the latest list
      await getAllMessages();
      await getNotifications();
      setNotificationAlert(message?.notification);
      setShowNotificationAlert(true);

      setTimeout(() => setShowNotificationAlert(false), 5000);
    });

    // Fetch initial notifications on mount
    getNotifications();
    getAllMessages();

    // Cleanup on component unmount
    return () => {
      socket.off("applicationStatusUpdate");
      socket.off("newapplicationadded");
      socket.off("newmessageget");
      socket.off("sendemployerforapprove");
      socket.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSocketNotification = (notification: Notification) => {
    // console.log("New notification received:", notification);
    // setNotifications((prev) => [notification, ...prev]);
    dispatch(addNotification(notification));
    setNotificationAlert(notification?.message);
    setShowNotificationAlert(true);

    setTimeout(() => setShowNotificationAlert(false), 5000);
  };

  const getNotifications = async () => {
    try {
      // setIsLoading(true);
      const response = await notificationList();
      if (response) {
        // setNotifications(response?.notifications);
        dispatch(setNotifications(response?.notifications));
      }
    } catch (err: any) {
      //   showError(err?.message);
    } finally {
      // setIsLoading(false);
    }
  };

  const getAllMessages = async () => {
    try {
      const response = await getMessageList();
      dispatch(setMessageList(response?.result));

      if (response?.result && response?.result.length > 0) {
        dispatch(setActiveChatId(response?.result[0]?._id));
        getChatList(response?.result[0]?._id);
      }
    } catch (error: any) {
      showError(error?.message);
    } finally {
    }
  };

  const getChatList = async (chatId: string = "") => {
    try {
      const response = await getChatBoardList(chatId);
      let messages = response?.result;
      const sortedMessages = [...messages].sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return dateA - dateB;
      });
      dispatch(setChatHistory(sortedMessages));
    } catch (error: any) {
      showError(error?.message);
    } finally {
    }
  };

  const handleMessage = () => {
    // if (messageList && messageList.length > 0) {
    if (activeChatId === undefined || activeChatId === null) {
      NavigateTo(AppRoute.EMPLOYER_MESSAGE);
    } else {
      NavigateTo(`${AppRoute.EMPLOYER_MESSAGE}/${activeChatId}`);
    }

    // }
  };

  const logoutAction = () => {
    dispatch(logOut());
    clearAllStorage();
    handleCloseWK();
    dispatch(clearNotifications());
    dispatch(clearChatData());
  };

  return (
    <>
      <header className="header tophdr common-padd-lt-rt">
        <div className="container-xxx">
          <div className="row">
            <div className="col-lg-12">
              <div className="hdrprofileholder">
                <div className="rightprofileinfo">
                  <h3>
                    Welcome Back, <span>{user?.firstName}</span>
                  </h3>
                  <div className="profilemenu">
                    <ul>
                      {/* {messageList && messageList.length > 0 && ( */}
                      <li>
                        <button onClick={handleMessage} className="messagelist">
                          <AiOutlineMessage />{" "}
                        </button>
                      </li>
                      {/* )} */}

                      <li>
                        <button
                          onClick={() => setShow(true)}
                          className="notificationmenu"
                        >
                          <SlBell />{" "}
                          <span
                            className={
                              notifications?.length > 0 ? `countvalue` : ""
                            }
                          >
                            {notifications && notifications?.length > 0
                              ? notifications?.length
                              : ""}
                          </span>
                        </button>
                      </li>
                      <li>
                        <Dropdown as={NavItem}>
                          <Dropdown.Toggle
                            className="profiledropdown"
                            as={NavLink}
                          >
                            <div className="profileimg">
                              <img
                                src={
                                  user?.profileimageurl
                                    ? user?.profileimageurl
                                    : UserProfileNoImg
                                }
                                alt="profile"
                              />
                            </div>
                            <h4>
                              {user?.firstName} {user?.lastName}
                              <span>Employer</span>
                            </h4>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              className=""
                              onClick={() =>
                                NavigateTo(AppRoute.EMPLOYER_MY_ACCOUNT)
                              }
                            >
                              <CiUser /> My Account
                            </Dropdown.Item>
                            <Dropdown.Item className="" onClick={handleShowWK}>
                              <MdOutlineLogout /> Log Out
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </li>
                      <li>
                        <Button
                          className="btnnoStyle mobileView"
                          variant="primary"
                          onClick={ddhandleShow}
                        >
                          <SlMenu />
                        </Button>
                      </li>
                    </ul>
                    <NotificationScreen
                      show={show}
                      setShow={setShow}
                      notifications={notifications}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/*========================= MOBILE OFF CANVAS =========================*/}

      <Offcanvas
        show={showoffcanvas}
        onHide={offhandleClose}
        backdropClassName="mobilesidebar"
      >
        <Offcanvas.Header closeButton className="p-0">
          {" "}
        </Offcanvas.Header>
        {/* <Offcanvas.Body> </Offcanvas.Body> */}
        <EmployerSidebarScreen />
      </Offcanvas>

      {/*========================= MOBILE OFF CANVAS =========================*/}
      {/* show notification alert */}
      {isShowNotificationAlert && (
        <Toast
          onClose={() => setShowNotificationAlert(false)}
          className="custom-toast-notification"
        >
          <Toast.Header>
            <strong className="me-auto">🔔 New Notification</strong>
          </Toast.Header>
          <Toast.Body>{notificationAlert}</Toast.Body>
        </Toast>
      )}

      {/* Log Out model*/}
      <Modal
        show={showWork}
        onHide={handleCloseWK}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody text-center">
            <Form className="logoutmdl">
              <div className="logouticon">
                <MdOutlineLogout />
              </div>
              <h3>Log Out</h3>
              <p>Are you sure you want to log out?</p>
              <p>
                You will need to log in again to access your account and view
                your job applications, notifications, and profile.
              </p>
              <div className="d-flex gp-10">
                <Button
                  className="btn btn-black w-100"
                  type="button"
                  onClick={handleCloseWK}
                >
                  Cancel
                </Button>
                <Button
                  className="btn w-100"
                  type="button"
                  onClick={logoutAction}
                >
                  Log Out
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* Log Out model*/}
    </>
  );
};
export default EmployerHeaderScreen;
